import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { schoolAdminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const reference = searchParams.get('reference');
  const [status, setStatus] = useState('verifying');
  const navigate = useNavigate();

  useEffect(() => {
    if (!reference) {
      setStatus('failed');
      return;
    }
    const verify = async () => {
      try {
        const res = await schoolAdminAPI.verifyPayment(reference);
        if (res.data.status === 'success') {
          setStatus('success');
          toast.success('Payment successful!');
          setTimeout(() => navigate('/admin/wallet'), 3000);
        } else {
          setStatus('failed');
          toast.error('Payment verification failed');
        }
      } catch (error) {
        setStatus('failed');
        toast.error('Verification error');
      }
    };
    verify();
  }, [reference, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow text-center">
        {status === 'verifying' && <p>Verifying payment...</p>}
        {status === 'success' && (
          <div>
            <i className="fas fa-check-circle text-5xl text-green-500 mb-4"></i>
            <h2 className="text-2xl font-bold text-green-700">Payment Successful!</h2>
            <p>Your wallet has been updated. Redirecting...</p>
          </div>
        )}
        {status === 'failed' && (
          <div>
            <i className="fas fa-times-circle text-5xl text-red-500 mb-4"></i>
            <h2 className="text-2xl font-bold text-red-700">Payment Failed</h2>
            <p>Please contact support or try again.</p>
            <button
              onClick={() => navigate('/admin/wallet')}
              className="mt-4 bg-primary-600 text-white px-4 py-2 rounded"
            >
              Go to Wallet
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentCallback;